import { PageTitle, PageContainer, FloatBox, Heading, CmsContent, useHead } from '@mybonus/ui';

const title = 'Användarvillkor';

export function UserTermsView() {
	useHead({ subtitle: title });

	return (
		<PageContainer width="narrow" noTopSpace>
			<PageTitle>
				<Heading level={1}>{title}</Heading>
			</PageTitle>

			<FloatBox>
				<CmsContent code="terms_text" />
			</FloatBox>
		</PageContainer>
	);
}
